/**
 * Analytics 공통 유틸리티
 */

export function truncate(str, max) {
  if (!str) return "";
  return str.length > max ? str.slice(0, max) : str;
}

export function getElementText(el) {
  try {
    var text = (
      el.innerText ||
      el.getAttribute("aria-label") ||
      el.getAttribute("title") ||
      ""
    ).trim();
    return truncate(text, 50);
  } catch (e) {
    return "";
  }
}
